import { render } from "./TablaIndicadores.vue?vue&type=template&id=bfd7697a"
import script from "./TablaIndicadores.vue?vue&type=script&lang=js"
export * from "./TablaIndicadores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__